import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props { active: 'outbox' | 'archive'; }

export const UnionInvitesSegments: React.FunctionComponent<Props> = ({ active }) => (
  <nav className="unionInvitesSegments" aria-label="Tournament invite folders">
    <Link className={active === 'outbox' ? 'is-active' : ''} to="/tournaments/invites/outbox">Outbox</Link>
    <Link className={active === 'archive' ? 'is-active' : ''} to="/tournaments/invites/archive">Resolved</Link>
  </nav>
);
